/**
 * Cookiebot consent utilities for checking user consent status.
 * Used to ensure GDPR compliance before processing user data.
 */

/**
 * Checks if Cookiebot is available and initialized.
 * @returns {boolean} True if Cookiebot is available, false otherwise.
 */
export function isCookiebotAvailable() {
  return (
    typeof window !== "undefined" &&
    window.Cookiebot &&
    window.Cookiebot.consent !== undefined
  );
}

/**
 * Checks if consent is given for marketing/advertising cookies.
 * @returns {boolean} True if consent is given, false otherwise.
 */
export function hasMarketingConsent() {
  if (!isCookiebotAvailable()) {
    return false;
  }

  // Strict GDPR compliance - only check marketing consent
  return window.Cookiebot.consent.marketing === true;
}

/**
 * Checks if consent is given for statistics/analytics cookies.
 * @returns {boolean} True if consent is given, false otherwise.
 */
export function hasStatisticsConsent() {
  if (!isCookiebotAvailable()) {
    return false;
  }

  return window.Cookiebot.consent.statistics === true;
}

/**
 * Checks if consent is given for preferences/functional cookies.
 * @returns {boolean} True if consent is given, false otherwise.
 */
export function hasPreferencesConsent() {
  if (!isCookiebotAvailable()) {
    return false;
  }

  return window.Cookiebot.consent.preferences === true;
}

/**
 * Checks if the user has responded to the cookie consent banner.
 * @returns {boolean} True if the user has responded, false otherwise.
 */
export function hasUserResponded() {
  if (!isCookiebotAvailable()) {
    return false;
  }
  return window.Cookiebot.hasResponse === true;
}
